import { useEffect, useState } from 'react';
import { Waypoint } from 'react-waypoint';
import ApolloMarkdown from '../../framework/components/ApolloMarkdown';
import '../scss/header/HeaderSimple.scss';
import '../scss/header/HeaderSmall.scss';

export default function HeaderSmall({ title, image }) {
    const [isInView, setIsInView] = useState(false);

    const [rawTitle, setTitle] = useState();

    const handleInView = () => setIsInView(true);
    const handleOutOfView = () => setIsInView(false);

    useEffect(() => {
        setTitle(title);
    }, [title, image]);

    return (
        <header className="headerSimple headerSmall">
            <Waypoint topOffset="25%" onEnter={handleInView} onLeave={handleOutOfView}>
                <div className="container">
                    <div className="row">
                        <div className="col col--7">
                            <div className={`underlineTitle ${isInView ? 'active' : ''}`}>
                                <h1>
                                    {rawTitle !== undefined && rawTitle.length > 0 ? (
                                        <ApolloMarkdown inline>{rawTitle}</ApolloMarkdown>
                                    ) : (
                                        ''
                                    )}
                                </h1>
                            </div>
                        </div>
                        {image ? (
                            <div className="col col--5">
                                <div className="image">
                                    <img src={image} alt="" />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
            </Waypoint>
        </header>
    );
}
